module.exports = __webpack_public_path__ + "static/media/_british-virgin-islands.ea35ce59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_british-virgin-islands.svg
// module id = 2307
// module chunks = 7